module.exports = __webpack_public_path__ + "static/Xenios40_old-a76675b5b97ff6416671265ca9e26f37.jpg";